import { decimalEqual, decimalNumber, type DecimalValue } from "./decimal";

export function reportingNumber(value: DecimalValue): number | null {
  const number = decimalNumber(value);
  return Number.isFinite(number) && decimalEqual(value, number) ? number : null;
}

export function reportingValue(value: DecimalValue): DecimalValue {
  return reportingNumber(value) ?? value;
}
